module.exports = __webpack_public_path__ + "static/img/pos_machine_icon.f352832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_machine_icon.png
// module id = oKmV
// module chunks = 8